import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

export const TestEditRedirect: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  if (!id) return <Navigate to="/app/tests" replace />;
  return <Navigate to={`/app/tests/${id}/settings`} replace />;
};

export default TestEditRedirect;
